__turbopack_context__.v({
  "button": "styles-module__zG0uZG__button",
  "container": "styles-module__zG0uZG__container",
  "phoneLink": "styles-module__zG0uZG__phoneLink",
  "socialIcon": "styles-module__zG0uZG__socialIcon",
  "socials": "styles-module__zG0uZG__socials",
});
